"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var typography_1 = __importDefault(require("@prezzee/typography"));
var form_control_1 = require("@prezzee/form-control");
var style = __importStar(require("./InputAdornment.style"));
var InputAdornment = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, className = props.className, _a = props.component, component = _a === void 0 ? 'div' : _a, _b = props.disablePointerEvents, disablePointerEvents = _b === void 0 ? false : _b, _c = props.disableTypography, disableTypography = _c === void 0 ? false : _c, position = props.position, variantProp = props.variant, other = __rest(props, ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);
    var formControl = (0, form_control_1.useFormControl)();
    var variant = variantProp;
    if (variantProp && formControl.variant) {
        if (process.env.NODE_ENV !== 'production') {
            if (variantProp === formControl.variant) {
                console.error('The `InputAdornment` variant infers the variant prop ' +
                    'you do not have to provide one.');
            }
        }
    }
    if (formControl && !variant) {
        variant = formControl.variant;
    }
    var InputAdornmentRoot = component;
    return (
    // <FormControlContext.Provider value={null}>
    (0, jsx_runtime_1.jsx)(InputAdornmentRoot, __assign({ css: style.root({ position: position, disablePointerEvents: disablePointerEvents, variant: variant }), className: className, ref: ref }, other, { children: typeof children === 'string' && !disableTypography ? ((0, jsx_runtime_1.jsx)(typography_1.default, __assign({ color: "text.secondary" }, { children: children }))) : ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [position === 'start' ? (
                /* notranslate needed while Google Translate will not fix zero-width space issue */
                (0, jsx_runtime_1.jsx)("span", __assign({ className: "notranslate" }, { children: "\u200B" }))) : null, children] })) }))
    // </FormControlContext.Provider>
    );
});
InputAdornment.displayName = 'PrezzeeInputAdornment';
exports.default = InputAdornment;
//# sourceMappingURL=InputAdornment.js.map